require('./mortgageRequestAppraisalRequestStep3.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ constants
const { SECOND_STEP, EURO_TEXT, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const { MORTGAGE_REQUEST_APPRAISAL_REQUEST } = require('constants/operationTypes');
const { PEND_TASACION } = require('constants/mortgageRequestStates');

// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const MortgageRequestAppraisalRequestConfirmationData = require('../mortgageRequestAppraisalRequestConfirmationData/mortgageRequestAppraisalRequestConfirmationData');

// @ action
const getAppraisalVisitData = require('actions/mortgageRequest/mortgageRequestAppraisalRequest');

class MortgageRequestAppraisalRequestStep3 extends React.Component {
    componentDidMount(){
        const{ immState, history } = this.props;
        const currentState = immState.get('estado');
        const appraisalStateFlag = currentState !== PEND_TASACION;
        if(appraisalStateFlag){
            history.push('/myprofile/mortgage/property-value');
        }
    }

    render() {
        const { immEstates, immPayment, immAccounts, immAppraisalRequest } = this.props;
        const confirmationTitle = formatText('mortgageRequestAppraisalRequest-appraisalRequestConfirmationTitle');
        const confirmationSubtitle = formatText('mortgageRequestAppraisalRequest-appraisalRequestConfirmationSubtitle');

        let content;

        const accountId = immAppraisalRequest.getIn(['steps', SECOND_STEP, 'accountId']);
        const accountData = immAccounts.getIn(['byId', accountId]);
        const contractNumber = accountData.get('newContractNumber');
        const productData = accountData.get('newProduct');
        const ammount = immAppraisalRequest.getIn(['steps', SECOND_STEP, 'totalCost']);
        const paymentAccount = immPayment.get('paymentAccount').replace(/\s/g, '');
        const codbban = paymentAccount.substr(4);
        const controlDigits = paymentAccount.substr(2, 2);
        const countryCode = paymentAccount.substr(0, 2);
        const originAccount = `${CHARGE_ACCOUNT_PREFIX}${productData}${contractNumber}`;
        const destinationAccount = `${countryCode}${controlDigits}${codbban}`;

        const operationParams = {
            ammount,
            currency: EURO_TEXT,
            destinationAccount,
            originAccount
        };

        if (immAppraisalRequest.get('inProgress') || !immAppraisalRequest.get('getVisitDataSuccess')) {
            content = <LoadingSection />
        } else {
            content = (
                <div className="mortgage-request-appraisal-confirmation">
                    <header className="mortgage-request-appraisal-confirmation__confirmation-title">{confirmationTitle}</header>
                    <div className="mortgage-request-appraisal-confirmation__confirmation-subtitle">{confirmationSubtitle}</div>

                    <MortgageRequestAppraisalRequestConfirmationData
                        immEstates={immEstates}
                        immPayment={immPayment}
                        immAccounts={immAccounts}
                        immAppraisalRequest={immAppraisalRequest}
                    />

                    <div className="mortgage-request-appraisal-confirmation__otp">
                        <SignaturePattern
                            operationType={MORTGAGE_REQUEST_APPRAISAL_REQUEST}
                            operationParams={operationParams}
                        />
                    </div>
                </div>
            )
        }

        return content;
    }
}

MortgageRequestAppraisalRequestStep3.propTypes = {
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    getAppraisalVisit: PropTypes.func.isRequired,
    immAppraisalRequest: PropTypes.object.isRequired,
    mortgageRequestPayment: PropTypes.object.isRequired,
    immState: PropTypes.object.isRequired,
    history: PropTypes.object,
};

module.exports = withRouter(connect(
    state => ({
        immAppraisalRequest: state.mortgageRequestAppraisalRequest,
        mortgageRequestPayment: state.mortgageRequestPayment
    }), {
        getAppraisalVisit: getAppraisalVisitData.getAppraisalVisit
    }
)(MortgageRequestAppraisalRequestStep3));